import { ChevronsUpDown } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { DataTableSkeleton } from '@/components/data-table/data-table-skeleton';
import { ErrorBoundarySuspense } from '@/components/error-boundary-suspense';
import { Button } from '@/components/ui/button';
import { GET_PURCHASE_PLANNING_SUPPLIERS_KEY } from '@/keys';
import { usePurchasePlanningWeek } from './hooks/use-purchase-planning-week';
import { PurchasePlanningCollapseCalendar } from './purchase-planning-collapse-calendar';
import { PurchasePlanningCreateLotSizing } from './purchase-planning-create-lot-sizing';
import { PurchasePlanningSupplierFilter } from './purchase-planning-supplier-filter';
import { PurchasePlanningTable } from './purchase-planning-table';

export function PurchasePlanning() {
  const { t } = useTranslation('purchasePlanning');
  const { queryKey } = usePurchasePlanningWeek();

  return (
    <div className='flex min-h-0 flex-1 flex-col'>
      <div className='relative mb-4 w-full'>
        <PurchasePlanningCreateLotSizing />
        <p className='mb-3 max-w-2xl text-muted-foreground text-sm'>
          {t('description')}
        </p>
        <div className='flex w-fit flex-nowrap items-start gap-2'>
          <ErrorBoundarySuspense
            errorFallbackWrapper={<div className='min-h-9 min-w-[240px]' />}
            loadingFallback={
              <Button
                className='h-9 min-w-[240px] justify-start'
                disabled
                variant='outline'
              >
                <div className='flex w-full items-center gap-1 text-muted-foreground'>
                  {t('selectOneOrMoreSuppliers')}
                  <ChevronsUpDown className='ml-auto size-4 shrink-0 opacity-50' />
                </div>
              </Button>
            }
            message={t('Unable to load purchase planning')}
            queryKey={GET_PURCHASE_PLANNING_SUPPLIERS_KEY}
          >
            <PurchasePlanningSupplierFilter />
          </ErrorBoundarySuspense>
          <PurchasePlanningCollapseCalendar />
        </div>
      </div>
      <div className='min-w-0 flex-1'>
        <ErrorBoundarySuspense
          errorFallbackWrapper={<div className='mt-4 w-full max-w-md' />}
          loadingFallback={
            <DataTableSkeleton columnCount={6} filterCount={2} rowCount={8} />
          }
          message={t('Unable to load purchase planning')}
          queryKey={queryKey}
        >
          <PurchasePlanningTable />
        </ErrorBoundarySuspense>
      </div>
    </div>
  );
}
